export default __webpack_public_path__ + "static/media/circle-checked.754465e6.svg";